var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_713_1299)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_713_1299",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.926 45 45 34.926 45 22.5C45 10.074 34.926 0 22.5 0C10.074 0 0 10.074 0 22.5C0 34.926 10.074 45 22.5 45Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_713_1299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.926 45 45 34.926 45 22.5C45 10.074 34.926 0 22.5 0C10.074 0 0 10.074 0 22.5C0 34.926 10.074 45 22.5 45Z",
    stroke: "#509BC2",
    strokeWidth: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 24.429H24.429V33H21.57V24.429H13V21.57H21.571V13H24.429V21.571H33V24.429Z",
    fill: "#509BC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_713_1299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic-add.ed1bb8505c26ed12bdc8d22f0a13f978.svg";
export { ForwardRef as ReactComponent };